import React, { useMemo } from 'react';
import { View } from 'react-native';
import TouchableBounce from 'utils/packages/TouchableBounce';
import Text from 'design-system/Text';
import Spacer from 'design-system/Spacer';
import { IconLightBulb } from 'design-system/icons';
import { formatAmount } from 'utils';
import useStyles from 'hooks/useStyles';
import useIsTablet from 'hooks/useIsTablet';
import { useAppSelector } from 'store/hooks';
import { selectDefaultCurrency } from 'reducers/selectors';
import styleSet from './styles';
import { isIOS, isWeb } from '../../../../constants';
import IconGraterThan from './icons/IconGraterThan';
const strings = {
    title: 'Search by name,\ncategory, tag or note',
    subtitle: 'Or try out with these filters',
};
const HIT_SLOP = { top: 10, bottom: 10 };
const NoTransactions = ({ style, defaultCategoryName, defaultAmount, onApplyDefaultCategoryFilter, onApplyDefaultAmountFilter, }) => {
    const isTablet = useIsTablet();
    const styles = useStyles(styleSet);
    const currency = useAppSelector(selectDefaultCurrency);
    const spacerStyles = useMemo(() => {
        let height;
        if (isWeb) {
            height = '20%';
        }
        else if (isTablet) {
            height = '40%';
        }
        else if (isIOS) {
            height = '50%';
        }
        else {
            height = '60%';
        }
        return {
            height,
        };
    }, [isTablet]);
    return (<View style={[style, styles.noTransactionsMainContainer]}>
      <View style={styles.noTransactionsContainer}>
        <View style={styles.noTransactionsTitleContainer}>
          <Text Text-16 centered>
            {strings.title}
          </Text>
        </View>
        <Text TextThin-14 Gray centered>
          {strings.subtitle}
        </Text>
        <Spacer h={16}/>
        <View style={styles.row}>
          <TouchableBounce hoverStyle={styles.hoverOnDark} style={styles.noTransactionsTagContainer} onPress={onApplyDefaultCategoryFilter} hitSlop={HIT_SLOP}>
            <View style={styles.noTransactionsTag}>
              <IconLightBulb alt height={16} width={16}/>
              <Spacer w={4}/>
              <Text Text-16>{defaultCategoryName}</Text>
            </View>
          </TouchableBounce>
          <Spacer w={8}/>
          <TouchableBounce hitSlop={HIT_SLOP} hoverStyle={styles.hoverOnDark} style={styles.noTransactionsTagContainer} onPress={onApplyDefaultAmountFilter}>
            <View style={styles.noTransactionsTag}>
              <IconGraterThan />
              <Spacer w={4}/>
              <Text Numbers-16>{formatAmount(Number(defaultAmount), currency)}</Text>
            </View>
          </TouchableBounce>
        </View>
      </View>
      <View style={spacerStyles}/>
    </View>);
};
export default NoTransactions;
